import { FC, PropsWithChildren } from "react";
import { useWatch } from "react-hook-form";

import { RadioGroup, TextArea } from "capitalrx-components-2.0/lib/forms";

import { QuestionWrapper, QuestionnaireWrapperProps } from "./QuestionWrapper";

interface Props extends QuestionnaireWrapperProps {
  readonly radioLabel: string;
  readonly radioRequired?: boolean;
  readonly otherRequired?: boolean;
  readonly renderAnswerChoicesOnly?: boolean;
}

export const RadioMultiple: FC<PropsWithChildren<Props>> = ({
  radioLabel,
  radioRequired,
  name,
  children,
  disabled = false,
  otherRequired = false,
  isReadonly = false,
  renderAnswerChoicesOnly = false,
  ...rest
}) => {
  const radioValues = useWatch({ name });

  const other = radioValues === "other";

  let otherTextField: React.ReactNode;
  if (other)
    otherTextField = (
      <TextArea.Field
        name={`${name}_other`}
        placeholder={"Enter more information"}
        required={otherRequired}
        readOnly={isReadonly}
        hideLabel
      />
    );

  const choices = (
    <RadioGroup.Field
      name={name}
      label={radioLabel}
      required={radioRequired}
      disabled={disabled}
      readOnly={isReadonly}
      hideLabel={!radioLabel}
    >
      {children}
    </RadioGroup.Field>
  );
  let component = (
    <QuestionWrapper
      disabled={disabled}
      isReadonly={isReadonly}
      name={name}
      {...rest}
    >
      {choices}
      {otherTextField}
    </QuestionWrapper>
  );

  if (renderAnswerChoicesOnly) {
    component = choices;
  }
  return <>{component}</>;
};
